import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { Layout } from "./components/Layout";

import Index from "./pages/Index";
import BuildPage from "./pages/Build";
import ProfilePage from "./pages/Profile";
import ListPage from "./pages/List";
import Settings from "./pages/Settings";
import BrowseDecks from "./pages/BrowseDecks";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Index />} />
          <Route path="/build" element={<BuildPage />} />
          <Route path="/browse" element={<BrowseDecks />} />
          <Route path="/profile/:npub" element={<ProfilePage />} />
          <Route path="/list/:naddr" element={<ListPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;